export default __webpack_public_path__ + "static/media/mn.a6223b92.svg";